import { ReactElement } from 'react';
import { Spinner } from '@weareopenr/component-library';
import { useTimetable } from 'src/hooks/useTimetable';
import { SpinnerContainer } from 'src/components/SpinnerContainer';
import { TimetableDetailsForm } from './TimetableDetailsForm';
import { ICloseTimetableDetailsTrayOptions, ITimetableDetailsPreview } from './types';

export interface TimetableDetailsTrayContentProps {
  timetableId: string;
  onClose: (options?: ICloseTimetableDetailsTrayOptions) => void;
  // Only meaningful where a day-by-day view of the timetable sits behind the tray to preview
  // against (the Timetable page) - omitted where there's nothing to update live, e.g. the
  // Timetables list page's per-card summary.
  onPreview?: (details: ITimetableDetailsPreview) => void;
  openId: number;
}

export const TimetableDetailsTrayContent = ({
  timetableId,
  onClose,
  onPreview,
  openId,
}: TimetableDetailsTrayContentProps): ReactElement => {
  const { data, isLoading } = useTimetable(timetableId);
  const timetable = data?.data;

  if (isLoading || !timetable) {
    return (
      <SpinnerContainer>
        <Spinner size="large" colour="rainbow" />
      </SpinnerContainer>
    );
  }

  // Keyed by openId (not timetableId) so reopening the tray - even for the same timetable -
  // always mounts a fresh form, matching DuplicateTimetableTrayContent's openId convention.
  return <TimetableDetailsForm key={openId} timetable={timetable} onClose={onClose} onPreview={onPreview} />;
};

export default TimetableDetailsTrayContent;
